import { render, staticRenderFns } from "./dingTalk.vue?vue&type=template&id=37d976dc&scoped=true&"
import script from "./dingTalk.vue?vue&type=script&lang=js&"
export * from "./dingTalk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d976dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d976dc')) {
      api.createRecord('37d976dc', component.options)
    } else {
      api.reload('37d976dc', component.options)
    }
    module.hot.accept("./dingTalk.vue?vue&type=template&id=37d976dc&scoped=true&", function () {
      api.rerender('37d976dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/oauth/dingTalk.vue"
export default component.exports